import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { CallNumber } from '@ionic-native/call-number';
import { Contacts } from '@ionic-native/contacts';
import { SocialSharing } from '@ionic-native/social-sharing';
import { LokiDbProvider } from '../../providers/loki-db/loki-db';
import { NetworkConnectionProvider } from './../../providers/network-connection/network-connection';
import { Platform, ToastController, PopoverController } from 'ionic-angular';
import { InAppBrowser } from '@ionic-native/in-app-browser';



declare var google;

/*
  Generated class for the ActionsProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class ActionsProvider {

    loading = { star: false, add: false }

    constructor(public http: Http,
        public callNumber: CallNumber,
        public contacts: Contacts,
        public socialSharing: SocialSharing,
        private lokiDB: LokiDbProvider,
        private toastCtrl: ToastController,
        private network: NetworkConnectionProvider,
        private platform: Platform,
        private inAppBrowser: InAppBrowser,
        private popoverCtrl: PopoverController
    ) {

    }

    getDefNumber(c) {

        let num = '';

        if (c.mobile)
            num = c.mobile
        else if (c.fisso)
            num = c.fisso
        else if (c.phone)
            num = c.phone

        return num;

    }

    getArrayOfNumbers(c) {

        let numbers = [];



        if (c.mobile)
            numbers.push({ 'type': 'mobile', 'number': c.mobile });

        if (c.fisso)
            numbers.push({ 'type': 'Fisso', 'number': c.fisso });

        if (c.phone)
            numbers.push({ 'type': 'Phone', 'number': c.phone });

        return numbers;

    }

    getStringOfAllNumbers(c) {

        let stringaNumeriTel = '';
        if (c.mobile)
            stringaNumeriTel += "Mobile: " + c.mobile.replace(/\s+/g, '') + " ";

        if (c.fisso)
            stringaNumeriTel += "Fisso: " + c.fisso.replace(/\s+/g, '') + " ";

        if (c.phone)
            stringaNumeriTel += "Phone: " + c.phone.replace(/\s+/g, '');

        return stringaNumeriTel.trim(); //eventuali spazi vuoti finali
    }


    /**
     * Chiama il numero di default di un contatto passato come parametro
     * @param c contatto da chiamare
     */
    call(c) {

        let num = this.getDefNumber(c);
        this.callDirectNumber(num, c);

    }

    /**
     *  Chiama un numero passato direttamente come parametro, se gli si passa un contatto lo aggiunge
     *  alla gal
     * @param num numero da chiamare
     * @param contact contatto eventuale da aggiungere alla GAL (di default è null non lo aggiunge)
     */
    callDirectNumber(num, contact = null) {
        console.log("call")
        console.log(num)
        if (num != '')
            this.callNumber.callNumber(num, true)
                .then(() => {
                    console.log('Launched dialer!');
                    let isToggled = this.lokiDB.isAutosaveEnabled()

                    if (isToggled && contact) {
                        console.log("aggiungiamo il numero alla GAL");
                        this.add(contact);
                    }

                }).catch(() => console.log('Error launching dialer'));
    }

    /**
     * Metodo che presenta il popover per la chiamata tenendo premuto a lungo
     */
    longPressCallPopover(myEvent, c) { //this.campiProfilo[this.cont.mansione]

        myEvent.preventDefault();
        // per ottenere solo i numeri di telefono per la pressione prolungata
        let numeriTelefonoValidi = this.getArrayOfNumbers(c);

        //creo il popover solo se ho dei numeri visualizzati
        if (numeriTelefonoValidi.length > 0) {
            let popover = this.popoverCtrl.create('PopoverPage', { contact: c, numeri: numeriTelefonoValidi, call: true });
            popover.present({
                ev: myEvent,
            });
        }

    }


    add(c) {
        this.loading.add = true;
        this.lokiDB.addToGAL(c).then(() => {
            this.loading.add = false;
        })
            .catch(() => {
                this.loading.add = false;
            });

    }

    share(c, email) {

        //let num = this.getDefNumber(c);
        let num = this.getStringOfAllNumbers(c);

        let message = c.denom + "  " + num;
        let subject = message;

        message += " Email: " + this.getDefMail(c)

        console.log("== message ==")
        console.log(message)

        var options = {
            message: message,
            subject: subject
        }

        //console.log("share")
        //console.log(message)


        this.socialSharing.shareWithOptions(options).then(() => {
            //console.log("share: Success");
        }).catch(() => {
            console.error("share: failed");
        });

    }

    star(c) {
        this.loading.star = true;
        this.lokiDB.toogleStar(c)
            .then(() => {
                this.loading.star = false;
                this.lokiDB.getStarred();
            })
            .catch(() => {
                this.loading.star = false;
            });

    }

    isStar(c) {
        return this.lokiDB.isStar(c);
    }

    verifyConnection() {
        return this.network.verifyConnection();
    }

    getDefMail(c) {

        let mail = '';

        if (c.mailNeg && c.mailNeg != '')
            mail = c.mailNeg
        else if (c.mail && c.mail != '')
            mail = c.mail
        else if (c.email && c.email != '')
            mail = c.email

        return mail;

    }

    mailTo(c) {

        //mail inesistente
        if (c.length == 0) return;

        //console.log(c)
        //console.log("mail da inviare a " + this.getDefMail(c));
        //console.log("mail da inviare a " + c);
        let Link
        if (this.platform.is('core')) {
            Link = "https://mail.google.com/mail/u/0/?view=cm&fs=1&to=" + c + "&tf=1"
            window.open(Link, "_blank")
        } if (this.platform.is('ios') && this.lokiDB.isOpenGmailEnabled()) {
            console.log("siamo su IOS, provo ad aprire gmail")
            try {
                let url = "googlegmail:///co?to=" + c;
                //let browser = this.inAppBrowser.create(url, '_blank', 'hidden=yes');
                let x = window.open(url, "_system")
                x.close();
            } catch (e) {
                //Apro il client di default
                console.log("errore nell'apertura di gmail " + e)
                Link = "mailto:" + c;
                let x = window.open(Link, "_system")
                x.close();
            }
        } else {
            Link = "mailto:" + c;
            let x = window.open(Link, "_system")
            x.close();
        }


    }

    /* Qui utilizzo google maps sul mobile */
    loadingGoogleMaps(negozio) {

        //console.log("Loading maps mobile...");

        let self = this;
        let latitude = negozio.s_coord_lat;
        let longitude = negozio.s_coord_long;
        let label = encodeURI(negozio.displayName);

        if (Math.round(latitude) === 0 && Math.round(longitude) === 0) {
            //console.log("non abbiamo le coordinate del negozio, le ricerchiamo")
            // Initialize the Geocoder
            var geocoder = new google.maps.Geocoder();
            if (geocoder) {
                geocoder.geocode({
                    'address': negozio.s_addr1
                }, function (results, status) {
                    if (status == google.maps.GeocoderStatus.OK) {
                        latitude = results[0].geometry.location.lat();
                        longitude = results[0].geometry.location.lng();
                        let destination = latitude + ',' + longitude;
                        //console.log("coordinate ritrovate");
                        //console.log(destination)
                        //console.log("piattaforma:");
                        //console.log(self.platform.is('ios'))
                        //console.log(self.platform.is('android'))
                        //console.log(self.platform.platforms())
                        if (self.platform.is('ios')) {
                            console.log("siamo su IOS, google maps in avvio..")
                            let url = "comgooglemaps://?q=" + destination + "&zoom=" + 15;
                            let browser = self.inAppBrowser.create(url, '_system', 'hidden=yes');
                            //browser.close();
                            //let x = window.open('comgooglemaps://' + url);
                            //let x = window.open('comgooglemaps://?q=' + destination, + '(' + label + ')', '_system');
                            //x.close();
                        }
                        else {
                            console.log("siamo su Android, google maps in avvio..")
                            let x = window.open('geo:0,0?q=' + destination + '(' + label + ')', '_system');
                            //x.close();
                        }
                        //console.log("fine if platform");
                    }
                    else {
                        self.toastCtrl.create({
                            message: 'Unable to locate this address',
                            duration: 2000,
                            position: 'top'
                        }).present();

                        console.log("Errore recupero coordinate");
                    }
                });
            }
        } else {
            let destination = latitude + ',' + longitude;
            //console.log("Abbiamo gia le coordinate da backend")
            //console.log(destination);
            //console.log("piattaforma:");
            //console.log(this.platform.is('ios'))
            //console.log(this.platform.is('android'))
            //console.log(this.platform.platforms())
            if (this.platform.is('ios')) {
                console.log("siamo su IOS, google maps in avvio..")
                let url = "comgooglemaps://?q=" + destination + "&zoom=" + 15;
                let browser = this.inAppBrowser.create(url, '_system', 'hidden=yes');
                //browser.close();
                //let x = window.open('comgooglemaps://' + url);
                //let x = window.open('comgooglemaps://?q=' + destination, + '(' + label + ')', '_system');
                //x.close();
            }
            else {
                console.log("siamo su Android, google maps in avvio..")
                let x = window.open('geo:0,0?q=' + destination + '(' + label + ')', '_system');
                //x.close();
                //x.close();
            }
        }
    }

}



// WEBPACK FOOTER //
// ./src/providers/actions/actions.ts